import { render, staticRenderFns } from "./PlantingSocDistributionDateUpdate.vue?vue&type=template&id=254b828d"
import script from "./PlantingSocDistributionDateUpdate.vue?vue&type=script&lang=js"
export * from "./PlantingSocDistributionDateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports